<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <!--<div class="left-side-switch" onclick="sideChangeStatus();">
      <i class="fa" :class="status ? 'fa-angle-double-right':'fa-angle-double-left'"></i>
    </div>-->
    <h6
      class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
    >
      {{ $t("other.条件筛选") }}
    </h6>
    <div class="mg-t-20 pd-x-10 mg-b-40">
      <div class="form-group mg-b-10">
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            v-model="keyType"
            @change="filtrate"
          >
            <option value="">{{ $t("other.请选择任务类型") }}</option>
            <option
              v-for="(stock, index) in stockType"
              :key="stock.type"
              :value="stock.type"
            >
              {{
                (lang == "zh" && stock.name) ||
                (lang == "en" && stock.nameEn) ||
                stock.name
              }}
            </option>
          </select>
        </div>
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            @change="filtrate"
            v-model="keyStatus"
          >
            <option value="">{{ $t("other.请选择任务状态") }}</option>
            <option
              v-for="(status, index) in statusArr"
              :key="index"
              :value="index"
            >
              {{ $t(status) }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
      @click="filtrate()"
    >
      {{ $t("other.筛 选") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["status", "key_type", "key_status", "type_arr"],
  data() {
    return {
      keyStatus: "",
      keyType: "",
      statusArr: arrDict.downloadStatus,
      stockType: "",
      lang: localStorage.getItem("ourmallVendorLang") || this.$i18n.locale,
    };
  },
  watch: {
    key_type: function () {
      this.keyType = this.key_type;
    },
    key_status: function () {
      this.keyStatus = this.key_status;
    },
    type_arr: function () {
      this.stockType = this.type_arr;
    },
  },
  components: {},
  mounted() {},
  updated() {
    // custom scrollbar style
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  methods: {
    sideChangeStatus() {
      //$t('other.边栏状态改变')
      this.$emit("changeStatus");
    },
    filtrate() {
      this.$emit("filtrate", this.keyType, this.keyStatus);
    },
  },
};
</script>
